







































import Vue from 'vue'
import Alert from '@/components/Alert.vue'
import PosterTable from '@/components/PosterTable.vue'
import PairRow from '@/components/PairRow.vue'
import Worker from '@/components/Worker.vue'
import { mapGetters, mapState } from 'vuex'

export default Vue.extend({
  components: {
    Alert,
    PosterTable,
    PairRow,
    Worker,
  },

  computed: {
    ...mapState('session', ['admin']),
    ...mapGetters('shared', ['featureEnabled']),
    registerEnabled() {
      return this.featureEnabled('registrar_poster')
    },
  },
})
